// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-mobile[data-v-28ae02de] {\n  color: #0c91cc;\n  position: absolute;\n  top: 0px;\n  right: -50px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
